import { Flex, Box } from '@chakra-ui/react';
import { FC, useState } from 'react';

import StarFilled from '@/assets/icons/ic_star_filled.svg';
import StarOutlined from '@/assets/icons/ic_star_outlined.svg';

interface IVotingStars {
  voteSelected: number | null;
  setVoteSelected: (rating: number) => void;
}

export const VotingStars: FC<IVotingStars> = ({ voteSelected, setVoteSelected }) => {
  const [hovered, setHovered] = useState<number | null>(null);

  function shouldFill(i: number) {
    const shouldFillByHover = hovered !== null && i <= hovered;
    const shouldFillBySelect = voteSelected !== null && i <= voteSelected;

    // hover always has a priority
    return shouldFillByHover || shouldFillBySelect;
  }

  return (
    <Flex my={6}>
      {Array.from({ length: 5 }, (_, i) => {
        const rating = i + 1;

        return (
          <Box
            px={1}
            key={rating}
            cursor="pointer"
            onMouseEnter={() => setHovered(rating)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => setVoteSelected(rating)}
          >
            {shouldFill(rating) ? <StarFilled /> : <StarOutlined />}
          </Box>
        );
      })}
    </Flex>
  );
};
